import { Flex, Text } from '@skin-seoul/design-system';
export const ReviewEmpty = () => {
  return <Flex direction="column" align="flex-start" w="full" gap="8px" data-sentry-element="Flex" data-sentry-component="ReviewEmpty" data-sentry-source-file="ReviewEmpty.tsx">
      <Text color="neutral.700" textStyle="paragraph.small" fontWeight="semibold" data-sentry-element="Text" data-sentry-source-file="ReviewEmpty.tsx">
        Be the first to write a review!
      </Text>
      <Text color="neutral.700" textStyle="paragraph.small" fontWeight="normal" data-sentry-element="Text" data-sentry-source-file="ReviewEmpty.tsx">
        Tell others what you think!
      </Text>
    </Flex>;
};
export default ReviewEmpty;